/* Ella Stína: láréttar raðir á forsíðu (vörur og uppskriftir).
   Örvar fletta röðinni. Röð með data-es-autoplay flettir sjálf um eitt spjald á X sekúndna fresti og byrjar aftur fremst í lokin,
   en stoppar á meðan músin er yfir henni, á meðan eitthvað í henni er valið með lyklaborði, í nokkrar sekúndur eftir að notandi flettir sjálfur,
   þegar hún sést ekki á skjánum, þegar flipinn er ekki opinn og alltaf ef beðið er um minni hreyfingu. Stöðvunarhnappur stoppar hana alveg. */
(function () {
  if (window.__esRail) return;
  window.__esRail = true;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduce() { return !!(mq && mq.matches); }
  function behavior() { return reduce() ? 'auto' : 'smooth'; }

  function rails(scope) { return Array.prototype.slice.call(scope.querySelectorAll('[data-es-rail]')); }
  function current(scope) {
    var list = rails(scope);
    for (var i = 0; i < list.length; i++) { if (!list[i].hidden) return list[i]; }
    return null;
  }
  function step(rail) {
    var k = rail.children;
    if (!k.length) return rail.clientWidth;
    if (k.length < 2) return k[0].getBoundingClientRect().width;
    return Math.abs(k[1].getBoundingClientRect().left - k[0].getBoundingClientRect().left) || rail.clientWidth;
  }
  function atStart(rail) { return rail.scrollLeft <= 4; }
  function atEnd(rail) { return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4; }
  function move(rail, dir, page) {
    var s = step(rail);
    var n = page ? Math.max(1, Math.floor((rail.clientWidth + 8) / s)) : 1;
    rail.scrollBy({ left: dir * s * n, behavior: behavior() });
  }

  function init(scope) {
    if (scope.getAttribute('data-es-rail-init')) return;
    scope.setAttribute('data-es-rail-init', '1');
    var page = scope.hasAttribute('data-es-page');
    var nav = scope.querySelector('.es-rail-nav');
    var prev = scope.querySelector('[data-es-prev]');
    var next = scope.querySelector('[data-es-next]');
    var pauseBtn = scope.querySelector('[data-es-pause]');
    var auto = scope.querySelector('[data-es-autoplay]');
    var last = 0;
    function touched() { last = Date.now(); }

    function update() {
      var rail = current(scope);
      if (!rail) return;
      var loop = rail.hasAttribute('data-es-autoplay');
      if (prev) prev.disabled = atStart(rail);
      if (next) next.disabled = !loop && atEnd(rail);
      if (nav) nav.classList.toggle('is-static', rail.scrollWidth <= rail.clientWidth + 4);
    }
    var raf = 0;
    function queue() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; update(); }); }

    if (prev) prev.addEventListener('click', function () {
      var rail = current(scope); if (!rail) return;
      touched(); move(rail, -1, page);
    });
    if (next) next.addEventListener('click', function () {
      var rail = current(scope); if (!rail) return;
      touched();
      if (rail.hasAttribute('data-es-autoplay') && atEnd(rail)) rail.scrollTo({ left: 0, behavior: behavior() });
      else move(rail, 1, page);
    });
    rails(scope).forEach(function (rail) {
      rail.addEventListener('scroll', queue, { passive: true });
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) { rail.addEventListener(ev, touched, { passive: true }); });
    });
    window.addEventListener('resize', queue);
    /* Flokkahnappar skipta um röð: byrja fremst í nýju röðinni */
    scope.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest('.es-chip[data-es-tab]'))) return;
      setTimeout(function () { var rail = current(scope); if (rail) rail.scrollLeft = 0; update(); }, 0);
    });
    update();

    if (!auto) return;
    var secs = parseFloat(auto.getAttribute('data-es-autoplay')) || 3;
    var paused = false, hover = false, focus = false, inView = false;
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    });
    auto.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    auto.addEventListener('pointerleave', function () { hover = false; });
    scope.addEventListener('focusin', function (e) { if (auto.contains(e.target)) focus = true; });
    scope.addEventListener('focusout', function (e) { if (!auto.contains(e.relatedTarget)) focus = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(auto);
    } else { inView = true; }
    function sync() { if (pauseBtn) pauseBtn.hidden = reduce(); }
    sync();
    if (mq && mq.addEventListener) mq.addEventListener('change', sync);
    setInterval(function () {
      if (reduce() || paused || hover || focus || !inView || document.hidden) return;
      if (Date.now() - last < 6000) return;
      if (auto.scrollWidth <= auto.clientWidth + 4) return;
      if (atEnd(auto)) auto.scrollTo({ left: 0, behavior: 'smooth' });
      else move(auto, 1, false);
    }, secs * 1000);
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-es-rail-scope]'), init);
    if (root && root.hasAttribute && root.hasAttribute('data-es-rail-scope')) init(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
